<template>
  <main class="layout__main">
    <div v-if="isMobileApp" class="mobile-overlay"></div>
    <div class="divider"></div>
    <div :class="getSectionOrderClass('intro')">
      <Intro
        :image="$root.isMobile ? introCoverMobile : introCoverWide"
        :imagePadding="false"
        :imageAsBackground="true"
        :titleAbove="introTitleAbove"
        :title="introTitle"
        :subtitle="introSubtitle"
        :buttonText="introButtonText"
        :buttonAction="!isFinished ? { action: login } : null"
        :note="introNote"
        :invertTextColor="introInvertTextColor"
      ></Intro>
    </div>

    <div :class="getSectionOrderClass('textBlock')">
      <TextBlock
        v-if="textBlockItems.length > 0"
        :items="textBlockItems"
      />
    </div>

    <div :class="getSectionOrderClass('ambassador')">
      <Ambassador
        v-if="ambassadorItems.length > 0"
        :type="ambassadorsType || 'general'"
        :title="ambassadorsTitle"
        :items="ambassadorsValues"
      ></Ambassador>
    </div>

    <div :class="getSectionOrderClass('calendarBanner')">
      <div class="banner-wrapper">
        <div v-if="$root.isMobile" class="banner">
          <a href="#" @click.prevent="login"><img :src="calendar && calendar.calendarImages ? calendar.calendarImages.mobile : ''" /></a>
        </div>
        <div v-if="!$root.isMobile" class="banner">
          <a href="#" @click.prevent="login"><img :src="calendar && calendar.calendarImages ? calendar.calendarImages.desktop : ''" /></a>
        </div>
      </div>
    </div>

    <div :class="getSectionOrderClass('goal')">
      <div class="divider"></div>
      <Goal
        v-if="goalEnabled || goalStepsEnabled"
        :formatTotalKm="goalStepsEnabled ? formatTotalKmSteps : formatTotalKm"
        :formatCurrentKm="goalStepsEnabled ? formatCurrentKmSteps : formatCurrentKm"
        :totalKm="goalStepsEnabled ? goalSteps.necessaryDistance : goal.necessaryDistance"
        :currentKm="goalStepsEnabled ? goalSteps.completedDistance : goal.completedDistance"
        :currentMoney="goal && goalShowCharity ? `${goal.completedAmount} ₽` : ''"
        :localizedText="{
          distance: 'вместе преодолено', total: 'Вместе преодолеть:', amount: 'собрано во благо',
        }"
        fullWidth
        @distance-question="onShowDistance()"
        @money-question="onShowCharity()"
      ></Goal>
    </div>
    <div :class="getSectionOrderClass('getTasks')">
      <div class="divider"></div>
      <GetTasks
        v-if="tasksGuest && tasksGuest.values"
        id="tasks"
        :image="getTasksCover"
        title="Зарабатывайте баллы, выполняя задания"
        :subtitle="getTasksSubtitle"
        :fullWidth="$root.isMobile"
      >
        <TaskCard
          v-for="(task, i) in tasksGuest.values"
          :key="i"
          :stateLabels="{ available: 'до ', inProgress: 'Выполняется', checking: 'Проверяется', completed: 'Выполнено', failed: 'Вы не успели :(' }"
          :timeLabels="{ days: 'д', hours: 'ч' }"
          :styleLabels="{ special: 'Особое задание', daily: 'Ежедневное', repeat: 'Многоразовое' }"
          :image="task.images.mobile"
          :action="{ func: () => onShowTask(i) }"
          type="coins"
          state="available"
          :title="task.title"
          :subtitle="task.shortDescription"
          :cost="getTaskRewardRange(task)"
          :date="`${task.endDate}`"
          :itemsTotal="0"
          :itemsDone="0"
          :complexity="task.complexity"
          :isSpecial="task.isSpecial || false"
          :isDaily="task.isDaily || false"
          :isRepeat="false"
        ></TaskCard>
      </GetTasks>
    </div>

    <div v-if="bannerVk" :class="getSectionOrderClass('vkBanner')">
      <div class="banner-wrapper">
        <div v-if="$root.isMobile" class="banner">
          <a :href="bannerVkRedirectUrl" target="_blank">
            <img :src="bannerVk ? bannerVk.mobileImageUrl : ''" />
          </a>
        </div>
        <div v-if="!$root.isMobile" class="banner">
          <a :href="bannerVkRedirectUrl" target="_blank">
            <img :src="bannerVk ? bannerVk.desktopImageUrl : ''" />
          </a>
        </div>
      </div>
    </div>
    <div :class="getSectionOrderClass('tgBanner')">
      <div class="divider"></div>
      <div class="banner-wrapper">
        <div v-if="$root.isMobile" class="banner">
          <a :href="bannerTgLink" target="_blank">
            <img :src="bannerMobileTg ? bannerMobileTg : ''" />
          </a>
        </div>
        <div v-if="!$root.isMobile" class="banner">
          <a :href="bannerTgLink" target="_blank">
            <img :src="bannerDesktopTg ? bannerDesktopTg : ''" />
          </a>
        </div>
      </div>
      <div class="divider"></div>
    </div>

    <div :class="getSectionOrderClass('getRewards')">
      <GetRewards
        v-if="promotions !== null"
        id="market"
        :image="getRewardsCover"
        :title="getRewardsTitle"
        :subtitle="getRewardsSubtitle"
        :note="getRewardsNote"
        :fullWidth="false"
      >
        <RewardCard
          v-for="(promotion, i) in promotions.values"
          :key="i"
          :image="promotion.images ? promotion.images.mobile : ''"
          :action="{ func: () => onAction(i) }"
          type='coins'
          :state="isSmallQuantity(promotion) ? 'count' : ''"
          :stateLabels="{ available: 'В наличии', count: `${promotion.promocodeQty} шт.` }"
          :title="promotion.name"
          :subtitle="promotion.subTitle"
          :cost="promotion.priceInPoints"
        ></RewardCard>
      </GetRewards>
    </div>
    <div v-if="bannerCommunity" :class="getSectionOrderClass('dummyBanner')">
      <div class="banner-wrapper">
        <div v-if="$root.isMobile" class="banner">
          <a :href="bannerCommunity ? bannerCommunity.redirectUrl : ''" target="_blank">
            <img :src="bannerCommunity ? bannerCommunity.mobileImageUrl : ''" />
          </a>
        </div>
        <div v-if="!$root.isMobile" class="banner">
          <a :href="bannerCommunity ? bannerCommunity.redirectUrl : ''" target="_blank">
            <img :src="bannerCommunity ? bannerCommunity.desktopImageUrl : ''" />
          </a>
        </div>
      </div>
    </div>
    <div :class="getSectionOrderClass('nominations')">
      <Nominations
        v-if="nominationsItems.length > 0 && isNominationsActiveTabSelected"
        id="rating"
        style="width: 100%; max-width: 1024px;"
        :image="nominationsCover"
        :title="nominationsTitle ? nominationsTitle : 'Побеждайте в номинациях'"
        :tabs="nominationsTabs"
        :activeTab="nominationsActiveTab"
        :fullWidth="false"
      >
        <NominationCard
          v-for="item in nominationsItems"
          :key="item.nominationId"
          :image="getNominationImage(item)"
          :nominationText="getNominationDates(item)"
          :title="item.title"
          :rules="{ text: 'Правила', action: () => onShowRules(item) }"
          :prizes="{ text: 'Награды', action: () => onShowPrizes(item) }"
          :ratingText="{ general: 'Текущий рейтинг', personal: 'Вы в рейтинге' }"
          :values="getNominationRating(item)"
          @show-details="onShowRating(item)"
          data-group-id="0"
        ></NominationCard>
        <NominationCard
          v-for="item in teamNominationsItems"
          :key="item.nominationId"
          :nominationText="getNominationDates(item)"
          :title="item.title"
          type="personal"
          state="in-progress"
          class="team-rating"
          :ratingText="{ general: 'Текущий рейтинг', personal: 'Команда в рейтинге' }"
          :values="getNominationRating(item, true)"
          @show-details="onShowRating(item, true)"
          data-group-id="1"
        ></NominationCard>
      </Nominations>
    </div>

    <div :class="getSectionOrderClass('superprize')">
      <Superprize
        v-if="false"
        :image="superprizeCover"
        title="Главный приз"
        :subtitle="superprizeSubtitle"
        buttonText="Узнать больше"
        :buttonAction="{ action: onShowPrizes }"
      ></Superprize>
    </div>

    <div :class="getSectionOrderClass('howItWorks')">
      <HowItWorks
        v-if="false"
        :items="[
          { text: '<a href=/register>Зарегистрируйтесь</a> на чемпионат' },
          { text: 'Установите трекер <a href=https://strava.com target=_blank>Strava</a> на смартфон' },
          { text: 'Подключите ваш трекер к чемпионату' },
          { text: 'Включайте трекер во время тренировки <span>для учёта ваших километров</span>' },
        ]"
      ></HowItWorks>
    </div>
    <div :class="getSectionOrderClass('topCurators')">
      <TopCurators
      v-if="themeDone && showTopCurators"
      id="involvement-rating"
      ></TopCurators>
    </div>

    <div :class="getSectionOrderClass('partners')">
      <Partners
        v-if="showPartners"
        id="partners"
        title="Партнёры и спонсоры"
        :items="partnersValues"
        fullWidth
      ></Partners>
      <div v-if="showPartners"  class="divider"></div>
    </div>

    <div :class="getSectionOrderClass('cta')">
      <div v-if="showPartners" class="divider"></div>
      <section class="mobile-app-intro mobile-app-intro_cta">
        <div class="mobile-app-intro__content">
          <h2 class="mobile-app-intro__title">
            Станьте участником<br>
            уже сегодня
          </h2>

          <div class="mobile-app-intro__stores" aria-label="Скачать приложение">
            <a
              v-if="OS !== 'Android'"
              class="mobile-app-intro__store"
              href="https://apps.apple.com/ru/app/%D1%81%D0%BA%D0%B0%D1%83%D0%BD%D1%82/id6504521298"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img :src="appStoreImg" alt="Загрузите в App Store">
            </a>
            <a
              v-if="OS !== 'iOS'"
              class="mobile-app-intro__store"
              href="https://play.google.com/store/apps/details?id=pro.scount.app&pli=1"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img :src="googlePlayImg" alt="Доступно в Google Play">
            </a>
            <a
              v-if="OS !== 'iOS'"
              class="mobile-app-intro__store"
              href="https://www.rustore.ru/catalog/app/pro.scount.app"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img :src="rustoreImg" alt="Доступно в RuStore">
            </a>
          </div>

          <div v-if="mobileAppLink" class="mobile-app-intro__qr-row">
            <div class="mobile-app-intro__qr-text">
              Наведите камеру на этот код<br>
              и скачивайте приложение
            </div>
            <div
              class="mobile-app-intro__qr"
              aria-label="QR-код для скачивания приложения БегунДа"
            >
              <img
                v-if="mobileAppQrCode"
                :src="mobileAppQrCode"
                alt="QR-код для скачивания приложения БегунДа"
              >
            </div>
          </div>
        </div>

        <div class="mobile-app-intro__visual" aria-hidden="true">
          <img :src="ctaPhonesImg" alt="">
        </div>
      </section>
    </div>

    <div class="under-maintenance" v-if="showUnderMaintenance">
      <Alert
        text="Внимание! Идет сборка и настройка тестовой среды. Некоторые функции могут не работать или работать некорректно."
        actionText="Понятно"
        state="warning"
        closable
        stacked
      >
      </Alert>
    </div>

    <RulesPrizesModal
      :active="rulesPrizesModal"
      :image="rulesPrizesImage"
      :title="rulesPrizesTitle"
      :subtitle="rulesPrizesSubtitle"
      :nominationId="rulesPrizesNominationId"
      :isTeam="rulesPrizesIsTeam"
      :state="rulesPrizesState"
      :tabs="!isPrivate ? rulesPrizesTabs : rulesPrizesCurrentTabs"
      :activeTab="rulesPrizesTabActive"
      @close="rulesPrizesModal = false"
    />

    <DistanceCharityModal
      :active="distanceCharityModal"
      :type="distanceCharityType"
      :localizedText="distanceCharityLocalizedText"
      :moreLink="'https://mail.ru/'"
      @close="distanceCharityModal = false"
    />

    <TaskDetailsModal
      :active="taskDetailsModal"
      state="available"
      :modalOptions="taskDetailsOptions"
      :rating="taskRating"
      @close="taskDetailsModal = false"
    />

  </main>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Cookies from 'js-cookie';
import dayjs from 'dayjs';
import QRCode from 'qrcode';
// componenets
import Intro from '@sc-component-library/intro/src/main';
import Goal from '@sc-component-library/goal/src/main';
import Nominations from '@sc-component-library/nominations/src/main';
import NominationCard from '@sc-component-library/nomination-card/src/main';
import Superprize from '@sc-component-library/superprize/src/main';
import HowItWorks from '@sc-component-library/how-it-works/src/main';
import GetTasks from '@sc-component-library/get-tasks/src/main';
import TaskCard from '@sc-component-library/task-card/src/main';
import Ambassador from '@sc-component-library/ambassador/src/main';
import GetRewards from '@sc-component-library/get-rewards/src/main';
import RewardCard from '@sc-component-library/reward-card/src/main';
import Partners from '@sc-component-library/partners/src/main';
import Alert from '@rr-component-library/alert/src/main';
import TopCurators from '@/components/TopCurators/TopCurators.vue';
import TextBlock from '@/components/TextBlock/TextBlock.vue';
import RulesPrizesModal from '@/components/RulesPrizesModal/RulesPrizesModal.vue';
import DistanceCharityModal from '@/components/DistanceCharityModal/DistanceCharityModal.vue';
import TaskDetailsModal from '@/components/TaskDetailsModal/TaskDetailsModal.vue';
import {
  scrollToId, formatDateRange, addNonBreakingSpaces, formatNumber, formatSingleDate,
  formatDateRangeIntro,
} from '@/assets/js/helpers';

// resources
import SuperprizeCover from '../assets/img/superprize/superprize.jpg';
import NominationsCover from '../assets/img/nominations/winner.png';
import GetTasksCover from '../assets/img/get-tasks/get-coins.svg';
import GetRewardsCover from '../assets/img/get-rewards/spend-coins.svg';
import AppStoreImg from '../assets/img/connection-guide/app-store.svg';
import GooglePlayImg from '../assets/img/connection-guide/google-play.svg';
import RuStoreImg from '../assets/img/connection-guide/rustore.svg';
import PhonesImg from '../assets/img/mobile-app-intro/phones.png';

export default {
  name: 'Home',
  components: {
    Intro,
    Goal,
    Nominations,
    NominationCard,
    Superprize,
    HowItWorks,
    GetTasks,
    TaskCard,
    Ambassador,
    GetRewards,
    RewardCard,
    Partners,
    Alert,
    TopCurators,
    TextBlock,
    RulesPrizesModal,
    DistanceCharityModal,
    TaskDetailsModal,
  },
  data() {
    return {
      superprizeCover: SuperprizeCover,
      appStoreImg: AppStoreImg,
      googlePlayImg: GooglePlayImg,
      rustoreImg: RuStoreImg,
      mobileAppQrCode: '',
      rulesPrizesModal: false,
      rulesPrizesImage: '',
      rulesPrizesTitle: '',
      rulesPrizesSubtitle: '',
      rulesPrizesNominationId: '',
      rulesPrizesIsTeam: false,
      rulesPrizesState: 'general',
      rulesPrizesTabs: [
        {
          title: 'Правила',
          enabled: true,
          content: '',
        },
        {
          title: 'Награды',
          enabled: true,
          content: '',
        },
        {
          title: 'Рейтинг',
          enabled: true,
        },
      ],
      rulesPrizesCurrentTabs: [
        {
          title: 'Правила',
          enabled: true,
          content: '',
        },
        {
          title: 'Награды',
          enabled: true,
          content: '',
        },
      ],
      rulesPrizesTabActive: 0,
      distanceCharityModal: false,
      distanceCharityType: '',
      distanceCharityLocalizedText: {
        title: '',
        subtitle: '',
      },
      taskDetailsModal: false,
      taskDetailsOptions: {},
      showUnderMaintenance: false,
      nominationsTabs: [],
      nominationsItems: [],
      nominationsActiveTab: null,
      teamNominationsItems: [],
      calendarModal: false,
      textBlockItems: [],
      ambassadorItems: [],
      bannersItems: [],
      taskRating: {},
      calendarData: [],
      goalStepsEnabled: false,
      contributionPercentageSteps: 0,
      totalDistanceSteps: 0,
      completedDistanceSteps: 0,
      goalEnabled: false,
    };
  },
  computed: {
    ...mapGetters('settings', ['theme', 'themeDone', 'isPrivate', 'options', 'resources']),
    ...mapGetters('exercises', ['tasksGuest', 'taskGuest', 'taskPoints', 'responseStatus']),
    ...mapGetters('market', ['promotions']),
    ...mapGetters('nominations', ['nominations', 'teamNominationsActive']),
    ...mapGetters('goals', ['goal', 'goalSteps']),
    ...mapGetters('content', ['onboardingItems', 'contentStatus', 'ambassadors', 'banners', 'introSections', 'partners']),
    ...mapGetters('calendar', ['calendar', 'calendarStatus']),
    ...mapGetters('user', ['isMobileApp']),
    formatTotalKmSteps() {
      return this.goalSteps ? formatNumber(this.goalSteps.necessaryDistance, 'км') : '0 км';
    },
    formatCurrentKmSteps() {
      return this.goalSteps ? formatNumber(this.goalSteps.completedDistance, 'км') : '0 км';
    },
    showTopCurators() {
      return this.options ? this.options.showTopCurators === true : false;
    },
    isTeamsEnabled() {
      return this.options ? this.options.isTeamsEnabled === true : false;
    },
    showTeamRatings() {
      return this.options ? this.options.showTeamRatings === true : false;
    },
    showAmbassadors() {
      return this.options ? this.options.showAmbassadors === true : false;
    },
    ambassadorsType() {
      return this.options ? this.options.ambassadorsType || '' : 'general';
    },
    ambassadorsValues() {
      return this.ambassadors ? this.updatedAmbassadors() || [] : [];
    },
    bannersValues() {
      return this.banners ? this.updateBanners() || [] : [];
    },
    bannerCalendar() {
      return this.banners ? this.banners.filter((i) => i.locationPlacement === 'calendar')[0] : {};
    },
    bannerCommunity() {
      return this.banners ? this.banners.filter((i) => i.locationPlacement === 'community')[0] : {};
    },
    showPartners() {
      return Array.isArray(this.partners) && this.partners.length > 0;
    },
    partnersValues() {
      if (!this.partners || !Array.isArray(this.partners)) return [];
      return this.partners.map((partner) => ({
        image: partner.logo || '',
        link: partner.link || '',
      }));
    },
    introImageAsBackground() {
      return this.options ? this.options.introImageAsBackground === true : false;
    },
    ctaImageAsBackground() {
      return this.options && this.options.ctaImageAsBackground !== undefined ? this.options.ctaImageAsBackground : this.introImageAsBackground;
    },
    introInvertTextColor() {
      return this.introSections ? this.introSections.topSectionButtonInversion === true : false;
    },
    showCalendarBanner() {
      return this.options ? this.options.showCalendarBanner === true : false;
    },
    showCalendarOnHome() {
      return this.options ? this.options.showCalendarOnHome === true : false;
    },
    goalShowCharity() {
      return this.options ? this.options.goalShowCharity === true : false;
    },
    homeSections() {
      return this.options ? this.options.homeSections || null : null;
    },
    isFinished() {
      return this.options ? this.options.isFinished === true : false;
    },
    showCalendar() {
      return this.showCalendarBanner && this.showCalendarOnHome;
    },
    introCover() {
      return this.introSections ? this.introSections.topSectionDesktopImageUrl || '' : '';
    },
    introCoverWide() {
      return this.introSections ? this.introSections.topSectionDesktopImageUrl || '' : '';
    },
    introCoverMobile() {
      return this.introSections ? this.introSections.topSectionMobileImageUrl || '' : '';
    },
    introTitleAbove() {
      if (!this.introSections) return '';
      const datesString = this.introSections.topSectionDates || '';
      if (!datesString) return '';

      const dateRanges = datesString.split(' - ');
      if (dateRanges.length === 1) {
        return formatSingleDate(dateRanges[0]);
      }
      if (dateRanges.length === 2) {
        return formatDateRangeIntro(dateRanges[0], dateRanges[1]);
      }
      return '';
    },
    introTitle() {
      return this.introSections ? this.introSections.topSectionTitle || '' : '';
    },
    introSubtitle() {
      return this.introSections ? this.introSections.topSectionShortDescription || '' : '';
    },
    introButtonText() {
      return this.introSections ? this.introSections.topSectionButtonText || '' : '';
    },
    introNote() {
      return this.introSections ? this.introSections.topSectionRestrictions || '' : '';
    },
    ambassadorsTitle() {
      return this.resources ? this.resources.ambassadorsTitle || '' : 'Вас будут поддерживать и мотивировать';
    },
    calendarBanner() {
      return this.resources ? this.resources.calendarBanner || '' : '';
    },
    calendarBannerMobile() {
      return this.resources ? this.resources.calendarBannerMobile || '' : '';
    },
    dummyBanner() {
      return this.resources ? this.resources.dummyBanner || '' : '';
    },
    dummyBannerMobile() {
      return this.resources ? this.resources.dummyBannerMobile || '' : '';
    },
    goalModalSubtitle() {
      return this.resources ? this.resources.goalModalSubtitle || '' : '';
    },
    goalModalCharityTitle() {
      return this.resources ? this.resources.goalModalCharityTitle || '' : '';
    },
    goalModalCharitySubtitle() {
      return this.resources ? this.resources.goalModalCharitySubtitle || '' : '';
    },
    getTasksCover() {
      return this.resources ? this.resources.getTasksCover || GetTasksCover : GetTasksCover;
    },
    getTasksSubtitle() {
      return this.resources ? this.resources.getTasksSubtitle || '' : '';
    },
    getRewardsCover() {
      return this.resources ? this.resources.getRewardsCover || GetRewardsCover : GetRewardsCover;
    },
    getRewardsTitle() {
      return this.resources ? this.resources.getRewardsTitle || '' : '';
    },
    getRewardsSubtitle() {
      return this.resources ? this.resources.getRewardsSubtitle || '' : '';
    },
    getRewardsNote() {
      return this.resources ? this.resources.getRewardsNote || '' : '';
    },
    nominationsCover() {
      return this.resources ? this.resources.nominationsCover || NominationsCover : NominationsCover;
    },
    nominationsTitle() {
      return this.resources ? this.resources.nominationsTitle || '' : '';
    },
    isNominationsActiveTabSelected() {
      if (!this.isTeamsEnabled || !this.showTeamRatings) return true;
      return this.nominationsActiveTab !== null;
    },
    superprizeSubtitle() {
      return addNonBreakingSpaces('200 слотов на марафон «Моя&nbsp;столица» получат первые 200 человек в номинации «Лучший&nbsp;атлет»');
    },
    formatTotalKm() {
      return this.goal ? formatNumber(this.goal.necessaryDistance, 'км') : '0';
    },
    formatCurrentKm() {
      return this.goal ? formatNumber(this.goal.completedDistance, 'км') : '0';
    },
    showTextBlock() {
      return this.homeSections ? this.homeSections.textBlock !== undefined : false;
    },
    showAmbassadorBlock() {
      return this.homeSections ? this.homeSections.ambassador !== undefined : false;
    },
    bannerDesktopTg() {
      return this.resources ? this.resources.chatBanner || '' : '';
    },
    bannerMobileTg() {
      return this.resources ? this.resources.chatBannerMobile || '' : '';
    },
    bannerTgLink() {
      return this.resources ? this.resources.chatLink || '' : '';
    },
    bannerVk() {
      if (!this.banners) return null;
      return this.banners.find((i) => i.locationPlacement === 'vk') || null;
    },
    bannerVkRedirectUrl() {
      return this.bannerVk && this.bannerVk.redirectUrl ? this.bannerVk.redirectUrl : '';
    },
    mobileAppLink() {
      return this.resources && this.resources.mobileAppLink
        ? this.resources.mobileAppLink
        : '';
    },
    ctaPhonesImg() {
      return this.resources && this.resources.ctaCover
        ? this.resources.ctaCover
        : PhonesImg;
    },
    OS() {
      const userAgent = navigator.userAgent || navigator.vendor || (window).opera;
      if (/android/i.test(userAgent)) return 'Android';
      if (/iPad|iPhone|iPod/i.test(userAgent) && !window.MSStream) return 'iOS';
      return 'unknown';
    },

  },
  watch: {
    themeDone(val) {
      if (val) {
        this.setNominationsTabs();
        this.setAmbassadorBlock();
        this.setTextBlock();
      }
    },
    mobileAppLink() {
      this.generateMobileAppQrCode();
    },
  },
  methods: {
    ...mapActions('exercises', ['getTasksGuest', 'getTaskPoints']),
    ...mapActions('market', ['getPromotions']),
    ...mapActions('nominations', ['getNominationsGuest', 'getTeamNominationsActive']),
    ...mapActions('goals', ['getGoal', 'getGoalSteps']),
    ...mapActions('content', ['getOnboardingItems', 'getAmbassadors', 'getBanners', 'getPartners']),
    ...mapActions('calendar', ['getCalendar']),
    onBanner() {
      if (this.bannerCommunity && this.bannerCommunity.redirectUrl) {
        window.open(this.bannerCommunity.redirectUrl, '_blank');
      } else {
        this.$router.push({ name: 'Community' }).catch(() => {});
      }
    },
    updateBanners() {
      return this.banners.map((banner) => ({
        location: banner.locationPlacement,
        desktopImage: banner.desktopImageUrl,
        mobileImage: banner.mobileImageUrl,
        url: banner.redirectUrl,
        order: banner.order,
      }));
    },
    updatedAmbassadors() {
      return this.ambassadors.map((ambassador) => ({
        name: ambassador.fullName,
        avatar: ambassador.desktopImageUrl,
        avatarMobile: ambassador.mobileImageUrl,
        taskText: ambassador.content,
        quote: ambassador.description,
      }));
    },
    login() {
      this.openInstallMobileModal();
    },
    openInstallMobileModal() {
      if (this.$root.$openInstallMobileModal) {
        this.$root.$openInstallMobileModal();
      }
    },
    onShowRules(item) {
      this.rulesPrizesTabs[0].content = item.rules || '';
      this.rulesPrizesTabs[1].content = item.awards || '';
      this.rulesPrizesTabs[2].enabled = true;
      this.rulesPrizesCurrentTabs[0].content = item.rules || '';
      this.rulesPrizesCurrentTabs[1].content = item.awards || '';
      this.rulesPrizesTabActive = 0;
      this.rulesPrizesImage = this.getNominationImage(item);
      this.rulesPrizesTitle = this.getNominationDates(item);
      this.rulesPrizesSubtitle = item.title;
      this.rulesPrizesModal = true;
    },
    onShowPrizes(item) {
      this.rulesPrizesTabActive = 1;
      this.rulesPrizesImage = this.getNominationImage(item);
      this.rulesPrizesTitle = this.getNominationDates(item);
      this.rulesPrizesSubtitle = item.title;
      this.rulesPrizesNominationId = item.nominationId;
      this.rulesPrizesIsTeam = false;
      this.rulesPrizesState = 'general';
      this.rulesPrizesTabs[0].content = item.rules || '';
      this.rulesPrizesTabs[1].content = item.awards || '';
      this.rulesPrizesTabs[2].enabled = true;
      this.rulesPrizesCurrentTabs[0].content = item.rules || '';
      this.rulesPrizesCurrentTabs[1].content = item.awards || '';
      this.rulesPrizesModal = true;
    },
    onShowRating(item, isTeam = false) {
      this.rulesPrizesTabs[0].content = item.rules || '';
      this.rulesPrizesTabs[1].content = item.awards || '';
      this.rulesPrizesTabs[2].enabled = true;
      this.rulesPrizesCurrentTabs[0].content = item.rules || '';
      this.rulesPrizesCurrentTabs[1].content = item.awards || '';
      this.rulesPrizesTabActive = 2;
      this.rulesPrizesImage = this.getNominationImage(item);
      this.rulesPrizesTitle = this.getNominationDates(item);
      this.rulesPrizesSubtitle = item.title;
      this.rulesPrizesNominationId = item.nominationId;
      this.rulesPrizesIsTeam = isTeam;
      this.rulesPrizesModal = true;
    },
    onShowDistance() {
      this.distanceCharityType = 'distance';
      this.distanceCharityLocalizedText = {
        title: 'Вместе преодолеть',
        subtitle: this.goalModalSubtitle ? this.goalModalSubtitle : 'Бегайте и ходите. Внесите свой вклад в достижение общей цели.',
      };
      this.distanceCharityModal = true;
    },
    onShowCharity() {
      this.distanceCharityType = 'charity';
      this.distanceCharityLocalizedText = {
        title: this.goalModalCharityTitle,
        subtitle: this.goalModalCharitySubtitle,
      };
      this.distanceCharityModal = true;
    },
    onShowTask() {
      this.openInstallMobileModal();
    },
    onAction() {
      this.openInstallMobileModal();
    },
    getCalendarBanner() {
      this.getCalendar()
        .then(() => {
          if (this.responseStatus === 200) {
            this.calendarData = this.calendar ? this.calendar : [];
          }
        });
    },
    isSmallQuantity(reward) {
      if (!reward) return false;
      return reward.promocodeQty <= 5;
    },
    isRepeat(task) {
      return task.type === 'Reusable';
    },
    getTaskReward(task) {
      // Если есть reward на уровне задания, используем его
      if (task && task.reward !== undefined && task.reward !== null) {
        return Math.round(task.reward);
      }

      // Иначе используем старую логику - суммируем из tasks
      let reward = 0;
      if (!task || !task.tasks) return reward;
      for (let i = 0; i < task.tasks.length; i += 1) {
        reward += task.tasks[i].reward;
      }
      return Math.round(reward);
    },
    getTaskRewardRange(task) {
      // Если есть reward на уровне задания, используем его (без диапазона)
      if (task && task.reward !== undefined && task.reward !== null) {
        return Math.round(task.reward);
      }

      // Иначе используем старую логику - суммируем из tasks с диапазоном
      let reward = 0;
      let maxReward = 0;
      if (!task || !task.tasks) return reward;
      for (let i = 0; i < task.tasks.length; i += 1) {
        reward += task.tasks[i].reward;
        maxReward += task.tasks[i].maxReward;
      }
      return maxReward && reward < maxReward ? `${Math.round(reward)}-${maxReward}` : Math.round(reward);
    },
    getIsFlexibleCost(task) {
      const reward = this.getTaskReward(task);
      if (!task || !task.tasks) return false;
      let maxReward = 0;
      for (let i = 0; i < task.tasks.length; i += 1) {
        maxReward += task.tasks[i].maxReward;
      }
      return reward < maxReward;
    },
    getNominationImage(item) {
      if (!item || !item.images) return '';
      return this.$root.isDesktop ? item.images.desktop || '' : item.images.mobile || '';
    },
    getNominationDates(item) {
      if (!item) return '';
      const startDate = dayjs.utc(item.startDate);
      const finishDate = dayjs.utc(item.finishDate);
      if (startDate.isValid() && finishDate.isValid()) {
        return formatDateRange({ start: startDate, finish: finishDate, showYear: true });
      }
      return '';
    },
    getNominationRating(item, isTeam = false) {
      if (!item) return [];
      const rating = [];
      for (let i = 0; i < item.leaders.length; i += 1) {
        const it = {
          number: item.leaders[i].position.toString(),
          name: isTeam ? item.leaders[i].teamName : item.leaders[i].name,
          value: item.leaders[i].points.toString(),
          current: false,
        };
        rating.push(it);
      }
      return rating;
    },
    setNominationsTabs() {
      if (this.isTeamsEnabled && this.showTeamRatings) {
        if (this.nominationsItems.length === 0 && this.teamNominationsItems.length === 0) {
          return;
        }
        this.nominationsTabs = [
          { title: 'Участники', enabled: this.nominationsItems.length > 0 },
          { title: 'Команды', enabled: this.teamNominationsItems.length > 0 },
        ];
        if (!this.nominationsTabs[0].enabled && this.nominationsTabs[1].enabled) {
          this.nominationsActiveTab = 1;
        } else {
          this.nominationsActiveTab = 0;
        }
        return;
      }
      this.nominationsActiveTab = 0;
    },
    getSectionOrderClass(id) {
      const hideClass = 'd-none';
      if (!this.homeSections) return 'flex-order-unset';

      // Для секции partners: если не указана в настройках, ставим ордер "3 с конца"
      if (id === 'partners' && !this.homeSections[id]) {
        const orders = Object.values(this.homeSections).filter((order) => typeof order === 'number');
        if (orders.length > 0) {
          const maxOrder = Math.max(...orders);
          const partnersOrder = maxOrder - 2;
          return `flex-order-${partnersOrder}`;
        }
        return 'flex-order-10';
      }

      if (!this.homeSections[id]) return hideClass;
      return `flex-order-${this.homeSections[id]}`;
    },
    setTextBlock() {
      if (this.showTextBlock) {
        this.getOnboardingItems()
          .then(() => {
            if (this.contentStatus === 200) {
              this.textBlockItems = this.onboardingItems || [];
            }
          });
      }
    },
    setAmbassadorBlock() {
      if (this.showAmbassadorBlock) {
        this.getAmbassadors()
          .then(() => {
            if (this.contentStatus === 200) {
              this.ambassadorItems = this.ambassadors || [];
            }
          });
      }
    },
    setBannersBlocks() {
      this.getBanners()
        .then(() => {
          if (this.contentStatus === 200) {
            this.bannersItems = this.banners || [];
          }
        });
    },
    generateMobileAppQrCode() {
      if (!this.mobileAppLink) {
        this.mobileAppQrCode = '';
        return;
      }
      const { mobileAppLink } = this;
      QRCode.toDataURL(mobileAppLink, {
        width: 68,
        margin: 0,
        color: {
          dark: '#000000',
          light: '#FFFFFF',
        },
      })
        .then((qrCode) => {
          if (mobileAppLink !== this.mobileAppLink) return;
          this.mobileAppQrCode = qrCode;
        })
        .catch(() => {
          this.mobileAppQrCode = '';
        });
    },
  },
  mounted() {
    const token = Cookies.get('token');
    if (token) {
      const involvementRating = '#involvement-rating';
      if (window.location.hash === involvementRating) {
        this.$router.replace(`/about${involvementRating}`).catch(() => {});
      } else {
        this.$router.push({ name: 'Dashboard' }).catch(() => {});
      }
      return;
    }
    this.generateMobileAppQrCode();
    if (this.themeDone) {
      this.setNominationsTabs();
      this.setTextBlock();
      this.setAmbassadorBlock();
      this.setBannersBlocks();
      this.getCalendarBanner();
    }
    this.getGoal()
      .then(() => {
        if (this.goal) {
          this.goalEnabled = this.goal?.isPrimaryGoalEnabled ? this.goal?.isPrimaryGoalEnabled : false;
          this.completedDistance = this.goal.completedDistance;
        }
      });
    this.getGoalSteps()
      .then(() => {
        if (this.goalSteps) {
          this.goalStepsEnabled = this.goalSteps?.isPrimaryGoalEnabled ? this.goalSteps?.isPrimaryGoalEnabled : false;

          this.completedDistanceSteps = formatNumber(this.goalSteps.completedDistance, '<span>км</span>');
        }
      });
    this.getTasksGuest({ offset: 0, count: 12 });
    this.getPromotions({ offset: 0, count: 12 });
    this.getPartners();
    this.getNominationsGuest({ offset: 0, count: 12 })
      .then(() => {
        this.nominationsItems = this.nominations ? this.nominations.values : [];
        if (!this.isTeamsEnabled || !this.showTeamRatings) return;
        this.getTeamNominationsActive({ offset: 0, count: 12 })
          .then(() => {
            this.teamNominationsItems = this.teamNominationsActive ? this.teamNominationsActive.values : [];
            this.setNominationsTabs();
          });
      });

    setTimeout(() => {
      if (window.location.hash) {
        const id = window.location.hash.length > 1 ? window.location.hash.slice(1) : '';
        if (id !== '') scrollToId(id, true);
      }
    }, 1000);
  },
};
</script>

<style lang="scss" scoped>
  .layout {
    &__main {
      display: flex;
      flex-direction: column;
    }
  }

  .under-maintenance {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    background-color: $color-warning-1;
    z-index: 2;

    ::v-deep .rr-alert {
      margin: 0 auto;
      max-width: 1024px;
      width: 100%;
      border-color: transparent;
    }

    ::v-deep .rr-alert__icon {
      width: 18px;
      height: 18px;
    }
  }

  .mobile-app-intro {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 48px;
    align-items: center;
    justify-content: space-between;
    max-width: 1200px;
    min-height: 560px;
    margin: 0 auto;
    padding: 64px;
    background: $color-white;

    @media (max-width: breakpoint(lg)) {
      grid-template-columns: 1fr;
      gap: 40px;
      padding: 48px 32px;
    }

    @media (max-width: breakpoint(md)) {
      min-height: auto;
      gap: 24px;
      padding: 32px 20px 48px;
    }

    &__content {
      width: 520px;
      max-width: 100%;

      @media (max-width: breakpoint(lg)) {
        max-width: none;
        width: 100%;
      }

      @media (max-width: breakpoint(md)) {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
      }
    }

    &__title {
      max-width: 420px;
      margin: 0 0 48px;
      color: $color-black;
      font-family: var(--font-family-2, inherit);
      font-size: map-get($heading-2-mobile, font-size);
      font-weight: bold;
      line-height: map-get($heading-2-mobile, line-height);
      overflow-wrap: break-word;

      @media (min-width: breakpoint(md)) {
        font-size: map-get($heading-2, font-size);
        line-height: map-get($heading-2, line-height);
      }

      @media (max-width: breakpoint(md)) {
        max-width: 320px;
        margin-bottom: 32px;
      }
    }

    &__stores {
      display: flex;
      flex-wrap: wrap;
      gap: 16px;
      margin-bottom: 72px;

      @media (max-width: breakpoint(md)) {
        flex-direction: column;
        align-items: center;
        gap: 16px;
        margin-bottom: 0;
      }
    }

    &__store {
      display: inline-flex;
      height: 40px;
      transition: transform 0.2s ease;

      &:hover {
        transform: translateY(-2px);
      }

      img {
        display: block;
        height: 40px;
      }
    }

    &__qr-row {
      display: flex;
      align-items: flex-end;
      gap: 24px;

      @media (max-width: breakpoint(md)) {
        display: none;
      }
    }

    &__qr-text {
      padding-right: 32px;
      padding-bottom: 23px;
      color: $color-black;
      background-image: url('../assets/img/mobile-app-intro/arrow.svg');
      background-repeat: no-repeat;
      background-position: right bottom;
      background-size: 104px 32px;
      font-size: map-get($text-lg, font-size);
      font-weight: $font-weight-semibold;
      line-height: map-get($text-lg, line-height);

      @media (max-width: breakpoint(md)) {
        padding-right: 0;
        padding-bottom: 0;
        background-image: none;
        font-size: 16px;
      }
    }

    &__qr {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 88px;
      height: 88px;
      background-color: $color-white;
      background-image: url('../assets/img/mobile-app-intro/r-frame.svg');
      background-repeat: no-repeat;
      background-position: center;
      background-size: 88px 88px;

      @media (max-width: breakpoint(md)) {
        width: 72px;
        height: 72px;
        background-size: 72px 72px;
      }

      img {
        display: block;
        width: 68px;
        height: 68px;

        @media (max-width: breakpoint(md)) {
          width: 56px;
          height: 56px;
        }
      }
    }

    &__visual {
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 0 0 auto;
      max-width: 360px;
      width: 100%;

      @media (max-width: breakpoint(lg)) {
        max-width: 320px;
        margin: 0 auto;
      }

      @media (max-width: breakpoint(md)) {
        order: -1;
        max-width: 240px;
      }

      img {
        display: block;
        width: 100%;
        height: auto;
        max-height: 480px;
        object-fit: contain;

        @media (max-width: breakpoint(md)) {
          max-height: none;
        }
      }
    }
  }

  ::v-deep .partners__container {
    @media (min-width: breakpoint(xl)) {
      max-width: 1272px;
    }
  }

  ::v-deep .intro__main {
    margin: 0;
    @media (min-width: breakpoint(xl)) {
      padding-left: 64px;
      padding-right: 64px;
    }

    @media (min-width: breakpoint(xxl)) {
      width: 50%;
    }
  }

  ::v-deep .intro .main__title {
    font-family: var(--font-family-2, inherit);
  }

  ::v-deep .intro .main__subtitle {
    a,
    a:link,
    a:hover,
    a:active,
    a:visited {
      color: var(--color-primary, #FF8233);
      font-weight: 600;
      text-decoration: none;
    }
  }

  ::v-deep .goal .goal__title {
    font-family: var(--font-family-2, inherit);
  }

  ::v-deep .get-tasks .get-tasks__info .info__title {
    font-family: var(--font-family-2, inherit);
  }

  ::v-deep .get-rewards .get-rewards__info .info__title {
    font-family: var(--font-family-2, inherit);
  }

  ::v-deep .nominations .info__title {
    font-family: var(--font-family-2, inherit);
  }

  ::v-deep .partners .partners__title {
    font-family: var(--font-family-2, inherit);
  }

  .team-rating ::v-deep .nomination-card__info--personal {
    justify-content: flex-end;
  }

  .team-rating ::v-deep .nomination-card__cover {
    display: none;
  }

  .banner {
    &-wrapper {
      padding: 8px;
      margin: 8px 0;
      &_gray  {
        background-color: $color-black-4;
      }
      @media (min-width: breakpoint(md)) {
        padding: 16px 32px;
      }
    }
    width: 100%;
    border-radius: 8px;
    overflow: hidden;

    ::v-deep img {
      width: 100%;
    }
  }

  ::v-deep .info__title {
    overflow-wrap: break-word;
  }

  .mobile-overlay {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
    background-color: $color-white;
  }
</style>
